import { useNavigate } from 'react-router-dom';
import { useCompare } from '@/context/CompareContext';
import { useTheme } from '@/context/ThemeContext';

export default function CompareBar() {
  const { selected, remove, clear } = useCompare();
  const { theme } = useTheme();
  const navigate = useNavigate();
  const light = theme === 'light';

  if (selected.length === 0) return null;

  return (
    <div
      className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-4 px-5 py-3 rounded-2xl border transition-all duration-300 ${
        light
          ? 'bg-white border-gray-200 text-gray-800'
          : 'bg-[#1C2B3A] border-white/10 text-white'
      }`}
      style={{ boxShadow: '0 8px 32px rgba(0,0,0,0.25)' }}
    >
      {/* Slots */}
      <div className="flex items-center gap-3">
        {[0, 1, 2].map((i) => {
          const p = selected[i];
          return (
            <div
              key={i}
              className={`relative flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm transition-all ${
                p
                  ? light
                    ? 'bg-gray-100 text-gray-800'
                    : 'bg-[#0D1B2A] text-white'
                  : light
                  ? 'bg-gray-50 border border-dashed border-gray-300 text-gray-400'
                  : 'bg-[#0D1B2A]/50 border border-dashed border-white/20 text-white/30'
              }`}
              style={{ minWidth: 130 }}
            >
              {p ? (
                <>
                  <span className="font-medium truncate max-w-[100px]">{p.name}</span>
                  <button
                    onClick={() => remove(p.id)}
                    className="ml-auto w-4 h-4 flex items-center justify-center text-xs opacity-60 hover:opacity-100 cursor-pointer"
                  >
                    <i className="ri-close-line"></i>
                  </button>
                </>
              ) : (
                <span className="text-xs">+ Add product</span>
              )}
            </div>
          );
        })}
      </div>

      <div className="w-px h-8 bg-current opacity-10 mx-1"></div>

      {/* Actions */}
      <div className="flex items-center gap-2">
        <button
          onClick={clear}
          className={`text-xs px-3 py-1.5 rounded-lg cursor-pointer whitespace-nowrap transition-colors ${
            light ? 'text-gray-500 hover:text-gray-800 hover:bg-gray-100' : 'text-white/50 hover:text-white hover:bg-white/10'
          }`}
        >
          Clear
        </button>
        <button
          disabled={selected.length < 2}
          onClick={() => navigate(`/products/compare?ids=${selected.map((p) => p.id).join(',')}`)}
          className="flex items-center gap-2 px-4 py-1.5 rounded-lg text-sm font-semibold whitespace-nowrap transition-all cursor-pointer text-white disabled:opacity-40 disabled:cursor-not-allowed"
          style={{ backgroundColor: 'var(--accent)' }}
        >
          <i className="ri-bar-chart-grouped-line"></i>
          Compare {selected.length > 0 ? `(${selected.length})` : ''}
        </button>
      </div>
    </div>
  );
}
